/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getGlobal = require("../../../../getGlobal");
var globalObject = (0, _getGlobal.getGlobal)();
function getSelectionStart(input) {
  if (!input) {
    return null;
  }
  if (input.createTextRange && !globalObject.getSelection) {
    var document = globalObject.document;
    var range = document.selection.createRange().duplicate();
    range.moveEnd('character', input.value.length);
    if (range.text == '') {
      return input.value.length;
    }
    return input.value.lastIndexOf(range.text);
  }
  return input.selectionStart;
}
var _default = getSelectionStart;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/ComboBox/src/utils/getSelectionStart.js
// module id = 671
// module chunks = 0